"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectDayjs = void 0;
var services_1 = require("../services");
var utils_1 = require("../utils");
var dayjs_1 = __importDefault(require("../locale/dayjs"));
var i18n_1 = __importDefault(require("./i18n"));
/** 注入dayjs的实例，将其置入国际化能力和响应监听， 由于dayjs是多实例的，故会全局生效  */
function injectDayjs(dayjs, lang) {
    (0, dayjs_1.default)(dayjs);
    // 注入文案后，需要设置一次语种
    var currentShortLang = (0, utils_1.langToShortLang)(lang || i18n_1.default.getLang());
    dayjs.locale(currentShortLang);
    services_1.pandaEvent.on('CHANGE_LANG', function (_lang) {
        dayjs.locale((0, utils_1.langToShortLang)(_lang));
    });
    return dayjs;
}
exports.injectDayjs = injectDayjs;
/** 注入Moment，将其置入国际化能力和响应监听，由于moment是单实例的，故会全局生效 */
// export function injectMoment<T extends { locale: (string) => void; }>(moment: T, lang: TLanauage): T {
//   loadMomentLocale(moment);
//   // 注入文案后，需要设置一次语种
//   const currentShortLang = langToShortLang(lang || $i18n.getLang());
//   moment.locale(currentShortLang);
//   pandaEvent.on('CHANGE_LANG', (_lang: TLanauage) => {
//     moment.locale(langToShortLang(_lang));
//   })
//   return moment;
// }
